import { type ReactNode } from 'react';

import { type StoreChatItem } from '@atlassian/conversation-assistant-store/controllers/chat/types';

export type MessageGroupRenderVersion = unknown;
export type ExplicitMessageGroupRenderVersion = NonNullable<MessageGroupRenderVersion>;

export type RenderMessage = (
	message: StoreChatItem,
	index: number,
	isLastAssistant: boolean,
) => ReactNode;
export type RenderOlderMessage = (message: StoreChatItem, index: number) => ReactNode;

export type LatestMessageRendererProps =
	| {
			renderLatestMessage?: undefined;
			renderLatestMessageVersion?: MessageGroupRenderVersion;
	  }
	| {
			renderLatestMessage: RenderMessage;
			renderLatestMessageVersion: ExplicitMessageGroupRenderVersion;
	  };

export type OlderMessageRendererProps =
	| {
			renderOlderMessage?: undefined;
			renderOlderMessageVersion?: MessageGroupRenderVersion;
	  }
	| {
			renderOlderMessage: RenderOlderMessage;
			renderOlderMessageVersion: ExplicitMessageGroupRenderVersion;
	  };

export const areRenderVersionsEqual = (
	previousVersion: MessageGroupRenderVersion,
	nextVersion: MessageGroupRenderVersion,
): boolean => {
	if (Object.is(previousVersion, nextVersion)) {
		return true;
	}

	if (!Array.isArray(previousVersion) || !Array.isArray(nextVersion)) {
		return false;
	}

	if (previousVersion.length !== nextVersion.length) {
		return false;
	}

	return previousVersion.every((previousField, index) =>
		Object.is(previousField, nextVersion[index]),
	);
};
